import { useEffect } from 'react'
import * as Sentry from '@sentry/browser'
import { getIsActiveQA } from '@shared/lib/helpers/autoTests/helpers'
import { useAppSelector } from '@app/model/store'

const DSN_PROD = 'https://97793a56aca9b85173da7f81485ec807@sentry-saas.rambler-co.ru/296' // EQEQEQ
const DSN_DEV = 'https://97793a56aca9b85173da7f81485ec807@sentry-saas.rambler-co.ru/296' // EQEQEQ

const APP_VERSION = process.env.NEXT_PUBLIC_APP_VERSION
const GITLAB_STATUS = process.env.GITLAB_STATUS || null
const IS_PROD = GITLAB_STATUS === '0'
const IS_STAGE = process.env.IS_STAGE || null

const checkSemVer = (thisAppVersion) =>
  new RegExp(
    /^((?:0|(?:[1-9]\d*)))\.((?:0|(?:[1-9]\d*)))\.((?:0|(?:[1-9]\d*)))(?:-([0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*))?(?:\+([0-9A-Za-z-]+(\.[0-9A-Za-z-]+)*))?$/gm,
  ).test(thisAppVersion)

// Подключение и настройка Sentry
export const useErrorCatcher = () => {
  const userId = useAppSelector((state) => state.global.user?.data?.afisha_id) || null
  const appVersion = !!APP_VERSION && checkSemVer(APP_VERSION) ? APP_VERSION : null

  useEffect(() => {
    const isTestRunner = getIsActiveQA()

    if (!isTestRunner) {
      const sentryOptions = {
        dsn: IS_PROD ? DSN_PROD : DSN_DEV,
        release: appVersion ? `ar-next@${appVersion}` : null,
        // allowUrls: [/https?:\/\/((www)\.)?afisha\.ru/],
        initialScope: (scope) => {
          scope.setTags({ userId })
          return scope
        },
      }

      // @ts-ignore
      Sentry.init({ ...sentryOptions })
    }
  }, [])
}
